/* eslint-disable */
import * as React from 'react';

import AppPage from '@/ui/AppPage/AppPage';
import Box from '@mui/material/Box';
import Permissions from '@/lib/permissions';
import TenantForm from './TenantForm';
import { useParams } from 'react-router-dom';
import dataController from '@/lib/DataController';
import model from '@/models/tenant';

function TenantPage() {
  const { id } = useParams();
  const dc = new dataController(model);

  const recordId = parseInt(id ? id : '', 10);

  return (
    <AppPage
      titlett="admin:page.tenants"
      needPermission={[Permissions.Administration]}
    >
      <Box m={2}>
        <TenantForm dc={dc} recordId={recordId} mode="update" form="update" />
      </Box>
    </AppPage>
  );
}

export default TenantPage;
